import { useGetPostsWithFeedback } from "./api";
import FeedbackTable from "./components/FeedbackTable";

const FeedbackView = () => {

  const { feedbackData } = useGetPostsWithFeedback()

  return (
    <div className="mt-[5vh] w-full sm:w-[calc(100%-4rem)] h-[95vh] min-h-[700px] overflow-hidden max-lg:overflow-x-hidden max-lg:overflow-auto p-1 md:p-4 pt-2">
      <div className="size-full overflow-auto">
        <div className="w-full flex items-center justify-between h-20">
          <h2 className="text-xl font-poppins pb-4 tracking-wide font-medium">Check Client Feedback</h2>
        </div>
        <div className="w-full h-[calc(100%-5rem)]">
          {feedbackData &&
            <FeedbackTable data={feedbackData.posts} />
          }
        </div>
      </div>
    </div>
  )
};

export default FeedbackView;

